import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import StudentCardFull from "../../component/student/StudentCardFull";
import { GetStudentList, studentListSelector } from "../slice";


//For Membership
import MembershipTNC from "../../component/Modal/MembershipTNC";
import ReadMore from "../../component/ReadMore/ReadMore";
import { useToggle } from "../../utils/hooks";
import moment from "moment";
import {
  addMemberShip,
  FetchMemberShipList,
  FetchMyMemberShipList,
  membershipListSelector,
  userDetailSelector,
} from "../slice";

import {
  changeDiscipline,
  changeStudentData,
  changeStudentType,
} from "../membership/MembershipSlice";

function AllStudent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const studentList = useSelector(studentListSelector);
  const [loading, setLoading] = useState(true);
  const [activeOption, setActiveOption] = useState(null);
  //For Membership
  const list = useSelector((state) => state.main.myMembershipList);
  const trialStudentsList = useSelector(
    (state) => state.main.trialStudentsList
  );
  const [selectedMembershipId, setSelectedMembershipId] = useState("");
  const [show, toggle] = useToggle(false);
  const [tnc, setTnc] = useState("");
  const user = useSelector(userDetailSelector);
  const [useWalletAmount, setUseWalletAmount] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState("");
  const [selectedTncIndex, setSelectedTncIndex] = useState("");
  const [errors, setErrors] = useState("");



  const getStudentList = useCallback(() => {
    setLoading(true);
    dispatch(GetStudentList({ all:true })).then(() => {
      setLoading(false);
    });
  }, [dispatch]);
  useEffect(() => {
    getStudentList();
  }, [getStudentList]);

  
  useEffect(() => {
    dispatch(FetchMyMemberShipList());
  }, [dispatch]);


  const handleRenewalDate = (data) => {
    const expiryDate = moment(data?.valid_till);
    const today = moment();
    let difference = expiryDate.diff(today, "days");
    console.log(difference, "Data");
    if (!data?.student_details?.deletedAt) {
      if (
        (Number(data?.membership_details?.no_of_days) > 30 &&
          difference < 30) ||
        (Number(data?.membership_details?.no_of_days) === 7 &&
          difference < 2) ||
        (Number(data?.membership_details?.no_of_days) === 1 &&
          difference < 1) ||
        difference < 0
      ) {
        return true;
      }
    }
    return false;
  };

  const handleExpired = (data) => {
    console.log(data, "Data");
    const expiryDate = moment(data?.valid_till);
    const today = moment();
    let difference = expiryDate.diff(today, "days");

    if (difference < 0) {
      return true;
    }

    return false;
  };

  // const isRenewal = handleRenewalDate();

  const onBuy = (data) => {
    console.log(data);
    if (!tnc) {
      setErrors("Kindly accept the terms and condition");
    } else {
      //  let price =
      //    student_type?.toLowerCase() === "child"
      //      ? Number(memberLevel?.child_price)
      //      : student_type?.toLowerCase() === "adult"
      //      ? Number(memberLevel?.adult_price)
      //      : 0;
      //  let walletUsedAmount =
      //    useWalletAmount && Number(user?.wallet) >= price
      //      ? price
      //      : useWalletAmount &&
      //        Number(user?.wallet) > 0 &&
      //        Number(user?.wallet) <= price
      //      ? Number(user?.wallet)
      //      : 0;
      //  let transaction_amount = price - walletUsedAmount;
      //  let payload;
      //  if (useWalletAmount) {
      //    payload = {
      //      data: {
      //        membership_level: memberLevel?.id,
      //        studentId: id,
      //        no_of_days: memberLevel?.no_of_days,
      //        price: price,
      //        wallet_used_amount: walletUsedAmount,
      //        transaction_amount,
      //      },
      //      payment_for: "membership",
      //      sub_payment_for: "changePlan",
      //      api: "auth/addMemberShipLevel",
      //    };
      //  } else {
      //    payload = {
      //      data: {
      //        membership_level: memberLevel?.id,
      //        studentId: id,
      //        no_of_days: memberLevel?.no_of_days,
      //        price: price,
      //        wallet_used_amount: "",
      //        transaction_amount: price,
      //      },
      //      payment_for: "membership",
      //      sub_payment_for: "changePlan",
      //      api: "auth/addMemberShipLevel",
      //    };
      //  }
      //  setLoading(true);
      //  if (!useWalletAmount) {
      //    (async () => {
      //      await localStorage.setItem(
      //        "addStudentWithMembershipPayload",
      //        JSON.stringify(payload)
      //      );
      //      dispatch(addStudentDataReducer(payload));
      //    })();
      //    postFormData("booking/createPaymentLink", {
      //      amount: payload.data?.transaction_amount,
      //      currency: "GBP",
      //      merchant_support_email: user?.email,
      //      payment_for: "membership",
      //      membership_id: memberLevel?.id,
      //      student_type: student_type,
      //      wallet_used_amount: 0,
      //    }).then((res) => {
      //      console.log(res, "Create payment api");
      //      if (res?.code === 1) {
      //        let URI = res?.data?.result?.paymentLink?.url;
      //        window.open(URI, "_self");
      //      } else {
      //        toast.error(res?.message, { autoClose: false, closeButton: true });
      //      }
      //    });
      //  } else if (useWalletAmount) {
      //    if (Number(user?.wallet) >= payload?.data?.price) {
      //      dispatch(addMemberShip(payload?.data)).then((res) => {
      //        setLoading(false);
      //        if (res?.payload?.code === 1) {
      //          // setShowPayment(true);
      //          navigate("/student", { replace: true });
      //          toast.success(res?.payload?.message);
      //        } else {
      //          toast.error(res?.payload?.message, { autoClose: false, closeButton: true });
      //        }
      //      });
      //    } else {
      //      (async () => {
      //        await localStorage.setItem(
      //          "addStudentWithMembershipPayload",
      //          JSON.stringify(payload)
      //        );
      //        dispatch(addStudentDataReducer(payload));
      //      })();
      //      postFormData("booking/createPaymentLink", {
      //        amount: payload.data?.transaction_amount,
      //        currency: "GBP",
      //        merchant_support_email: user?.email,
      //        payment_for: "membership",
      //        membership_id: memberLevel?.id,
      //        student_type: student_type,
      //        wallet_used_amount: walletUsedAmount,
      //      }).then((res) => {
      //        console.log(res, "Create payment api");
      //        if (res?.code === 1) {
      //          let URI = res?.data?.result?.paymentLink?.url;
      //          window.open(URI, "_self");
      //        } else {
      //          toast.error(res?.message);
      //        }
      //      });
      //    }
      //  }
    }
  };

  const handleBuy = () => {};
  const isActiveMembership = (item) => {
    return (
      item?.student_details?.trialAccountStatus === "3" &&
      item?.payment_status === "1"
    );
  };
  const isExpiredHandler = (item) => {
    const expiryDate = moment(item?.valid_till);
    const today = moment();
    let difference = moment.duration(expiryDate.diff(today)).asHours();

    if (difference <= 0) {
      return true;
    }
    return false;
  };


  return (
    <>
      {/* <section className="mt-4">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
              <div className="btn-flex">
                <a
                  href="make-bookings.html"
                  className="white-btn shadow tanitems"
                >
                  Make Bookings
                </a>
                <Link to="/all-student" className="white-btn shadow tanitems">
                  All Students
                </Link>
                <a href="my-booking.html" className="white-btn shadow tanitems">
                  My Bookings
                </a>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
              <div className="view-btns justify-content-end">
                <span className="btn-accept btn-view w-auto">
                  Balance/Credit:
                  <i className="fa fa-gbp" aria-hidden="true"></i> 24
                </span>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/*<section className="sec-bg py-4 px-3 bottom-space">
        <div className="container-fluid">
          <div className="row ">
            <div className="col-sm-12 col-md-6 col-lg-6 mt-3">
              <h3>All Students</h3>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 mt-3 text-end">
              <Link to="/add-student" className="h3">
                + Add New Student
              </Link>
            </div>

            {studentList?.map((item, i) => (
              <div className="col-sm-12 col-md-6 col-lg-4 mt-3" key={i}>
                <StudentCardFull data={item} refresh={getStudentList} />
              </div>
            ))}
          </div>
        </div>
      </section>*/}
     
      {/* Students Section */}
      <section className="sec-bg py-4 px-3 bottom-space">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6 mt-3">
              <h3>All Students</h3>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 mt-3 text-end">
              <Link to="/add-student" className="h3">
                + Add New Student
              </Link>
            </div>

            {studentList?.map((item, i) => (
              <div className="col-sm-12 col-md-6 col-lg-4 mt-3" key={i}>
                <StudentCardFull data={item} refresh={getStudentList} activeOption={activeOption} setActiveOption={setActiveOption}/>
              </div>
            ))}
          </div>
        </div>
      </section>

    </>
  );
}

export default AllStudent;
